import config from 'config';

export default () => {
  return !Number(config.org_id);
};
